import SensorDetail from './SensorDetail.vue'
import SensorDetailGraph from './SensorDetailGraph.vue'
import SensorDetailInfo from './SensorDetailInfo.vue'
import SensorDetailTable from './SensorDetailTable.vue'
import SensorCondition from './SensorCondition.vue'

export {
  SensorDetail,
  SensorDetailGraph,
  SensorDetailInfo,
  SensorDetailTable,
  SensorCondition
}
